import api from "./Api";

export interface IPosicaoFinanceiraPendencia {
    id: number;
    tipo: string;
    razaoSocial: string | null;
    dataProvisao: string | null;
    valorProvisao: number | null;
    numeroDocumento: string | null;
    encontrouProvisao: boolean;
    contaContabil: string | null;
    lancamentoIds: number[];
    arquivoOperacaoId: number | null;
    status: string | null;
}

export interface IPosicaoFinanceiraPendenciaFilter {
    page?: number;
    perPage?: number;
    somentePendentes?: boolean;
    tipo?: string;
    razaoSocial?: string;
    numeroDocumento?: string;
    contaContabil?: string;
    dataProvisaoInicio?: string;
    dataProvisaoFim?: string;
    encontrouProvisao?: boolean;
    arquivoOperacaoId?: number;
    contaContabilConciliacao?: string;
    incluirSobrescritos?: boolean;
}

export interface IPosicaoFinanceiraEstatisticas {
    totalAtivos: number;
    totalPendentes: number;
    conciliadosNaConta: number;
    conciliadosGeral: number;
    porcentagemConta: number;
    porcentagemGeral: number;
}

export interface IPosicaoFinanceiraPendenciaPage {
    items: IPosicaoFinanceiraPendencia[];
    total: number;
    page: number;
    perPage: number;
    totalPages: number;
}

class PosicaoFinanceiraService {
    async listarPendencias(esteiraId: number, filter: IPosicaoFinanceiraPendenciaFilter): Promise<IPosicaoFinanceiraPendenciaPage> {
        const params: Record<string, any> = {
            page: filter.page ?? 1,
            perPage: filter.perPage ?? 20,
            somentePendentes: filter.somentePendentes ?? true,
        };
        if (filter.tipo) params.tipo = filter.tipo;
        if (filter.razaoSocial) params.razaoSocial = filter.razaoSocial;
        if (filter.numeroDocumento) params.numeroDocumento = filter.numeroDocumento;
        if (filter.contaContabil) params.contaContabil = filter.contaContabil;
        if (filter.dataProvisaoInicio) params.dataProvisaoInicio = filter.dataProvisaoInicio;
        if (filter.dataProvisaoFim) params.dataProvisaoFim = filter.dataProvisaoFim;
        if (filter.encontrouProvisao !== undefined) params.encontrouProvisao = filter.encontrouProvisao;
        if (filter.arquivoOperacaoId !== undefined) params.arquivoOperacaoId = filter.arquivoOperacaoId;
        if (filter.contaContabilConciliacao) params.contaContabilConciliacao = filter.contaContabilConciliacao;
        if (filter.incluirSobrescritos !== undefined) params.incluirSobrescritos = filter.incluirSobrescritos;

        const { data } = await api.get<IPosicaoFinanceiraPendenciaPage>(
            `PosicaoFinanceira/esteira/${esteiraId}/pendencias`,
            { params }
        );
        return data;
    }

    async buscarEstatisticas(esteiraId: number, contaContabil: string): Promise<IPosicaoFinanceiraEstatisticas> {
        const { data } = await api.get<IPosicaoFinanceiraEstatisticas>(
            `PosicaoFinanceira/esteira/${esteiraId}/estatisticas`,
            { params: { contaContabil } }
        );
        return data;
    }
}

export default new PosicaoFinanceiraService();
